import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InfoIcon from "../../../../Images/informationIcon.png";
import Attachment from "../../../../Images/attachment.png";
import requiredImg from "../../../../Images/sp.gif";
import { BASE_FILE_URL, setUrl } from "../../../../handlers";
import { DisplayMsg } from "../../../../services/toastService";

const Setup = () => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [Detail, setDetail] = useState(null);
  const [Products, setProducts] = useState({});

  useEffect(() => {
    LoadPracticeSetup();
  }, []);

  const SetProductStatus = (e, type) => {
    const curVal = e.target.checked;
    switch (type) {
      case "tele":
        setProducts((productInfo) => ({
          ...productInfo,
          TeleMed: curVal,
        }));
        break;
      case "pm":
        setProducts((productInfo) => ({
          ...productInfo,
          Pm: curVal,
        }));
        break;
      case "rcm":
        setProducts((productInfo) => ({
          ...productInfo,
          Rcm: curVal,
        }));
        break;
      case "kiosk":
        setProducts((productInfo) => ({
          ...productInfo,
          Kiosk: curVal,
        }));
        break;
      case "ehr":
        setProducts((productInfo) => ({
          ...productInfo,
          Ehr: curVal,
        }));
        break;
      default:
        break;
    }
  };

  const LoadPracticeSetup = async () => {
    try {
      const formData = new FormData();
      formData.append("seqNum", sharedData.currentClientId);
      const response = await fetch(
        setUrl("PRACTICEDETAIL", "LOADPRACTICEDATA", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const json = await response.json();
      if (json && json.status) {
        if (json.PracticeData.length > 0) {
          LoadProductType(json.PracticeData[0].PRODUCT_TYPE);
          setDetail(json.PracticeData[0]);
        }
      } else {
        DisplayMsg(2, json.Message);
      }
    } catch (e) {
      DisplayMsg(2, "Unable to Process the Request");
    }
  };

  const LoadProductType = (productType) => {
    if (productType && productType.indexOf("K") >= 0) {
      setProducts((productInfo) => ({
        ...productInfo,
        Kiosk: true,
      }));
    }
    if (productType && productType.indexOf("T") >= 0) {
      setProducts((productInfo) => ({
        ...productInfo,
        TeleMed: true,
      }));
    }
    if (productType && productType.indexOf("E") >= 0) {
      setProducts((productInfo) => ({
        ...productInfo,
        Ehr: true,
      }));
    }
    if (productType && productType.indexOf("P") >= 0) {
      setProducts((productInfo) => ({
        ...productInfo,
        Pm: true,
      }));
    }
    if (productType && productType.indexOf("R") >= 0) {
      setProducts((productInfo) => ({
        ...productInfo,
        Rcm: true,
      }));
    }
  };

  const LoadLogo = (logoFile) => {
    const fileNameIndex = logoFile.lastIndexOf("\\") + 1;
    const fileName = logoFile.substr(fileNameIndex);
    return (
      <span
        role="button"
        className="form-text"
        onClick={() => DownloadLogoAttachment(fileName, "PRACTICE")}
      >
        {fileName}
      </span>
    );
  };

  const DownloadLogoAttachment = async (file, type) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("fileName", file);
        formData.append("seqNum", sharedData.currentClientId);
        formData.append("type", type);
        document.getElementById("loader").style.display = "block";
        const result = await fetch(
          setUrl("PRACTICEDETAIL", "DOWNLOADATTACHMENT"),
          {
            method: "POST",
            body: formData,
          }
        );
        const response = await result.json();
        if (response && response.status) {
          document.getElementById("loader").style.display = "none";
          window.open(
            `${BASE_FILE_URL +
              response.FILE_DIRECTORY 
              }&filename=${ 
              response.FILE_NAME}`
          );
        } else {
          document.getElementById("loader").style.display = "none";
          DisplayMsg("2", response.Message);
        }
      } else {
        DisplayMsg("2", "No Attahment Found");
      }
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "No to Process the Request");
    }
  };

  const UpdateProductType = async () => {
    try {
      const practiceSetupKiosk = Products.KiosK
        ? Products.KiosK === true
          ? "Y"
          : "N"
        : "N";
      const practiceSetupEHR = Products.Ehr
        ? Products.Ehr === true
          ? "Y"
          : "N"
        : "N";
      const practiceSetupPM = Products.Pm
        ? Products.Pm === true
          ? "Y"
          : "N"
        : "N";
      const practiceSetupRCM = Products.Rcm
        ? Products.Rcm === true
          ? "Y"
          : "N"
        : "N";
      const practiceSetupTelemed = Products.TeleMed
        ? Products.TeleMed === true
          ? "Y"
          : "N"
        : "N";

      const formData = new FormData();
      formData.append("practiceSetupKiosk", practiceSetupKiosk);
      formData.append("practiceSetupEHR", practiceSetupEHR);
      formData.append("practiceSetupPM", practiceSetupPM);
      formData.append("practiceSetupRCM", practiceSetupRCM);
      formData.append("practiceSetupTelemed", practiceSetupTelemed);
      formData.append("seqNum", sharedData.currentClientId);

      document.getElementById("loader").style.display = "block";
      const response = await fetch(
        setUrl("PRACTICEDETAIL", "UPDATEPRODUCTTYPE", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const json = await response.json();
      if (json.status) {
        DisplayMsg("1", "Updated successfully.");
      } else {
        DisplayMsg("2", json.Message);
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request.");
    }
  };

  return (
    <div className="client-section">
        <div className="row table-panel-header">
          <div className="col-md-12">
            <h6>Practice Detail</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder">
                Speciality{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.SPECIALITY : ""}
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="The specialty of the practice services"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder">
                Practice Name{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.PRACTICE_NAME : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder">Group NPI</label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled=""
                value={Detail ? Detail.GROUP_NPI : ""}
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="Billing NPI, if billing under group provide group NPI, otherwise provide individual NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder">Tax ID</label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled=""
                value=""
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="Unique 9-digit number assigned by IRS, linked with Group NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Address{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.ADDRESS : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                City{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.CITY : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                State{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.STATE : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Zip Code{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.ZIP_CODE : ""}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Zip Code Ext
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.ZIP_CODE_EXT : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Phone{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.PHONE_NO : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">Fax #</label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.PEHR_PROVIDED_FAX_NO : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                No. of Providers{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.NO_OF_PROVIDERS : ""}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <label className="field-placeholder label-top-text font-medium">
                Product Type{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <span className="product-catagory">
                EHR{" "}
                <input
                  type="checkbox"
                  onChange={(e) => SetProductStatus(e, "ehr")}
                  checked={Products.Ehr ? Products.Ehr : false}
                />
              </span>
              <span className="product-catagory">
                PM{" "}
                <input
                  type="checkbox"
                  onChange={(e) => SetProductStatus(e, "pm")}
                  checked={Products.Pm ? Products.Pm : false}
                />
              </span>
              <span className="product-catagory">
                RCM{" "}
                <input
                  type="checkbox"
                  onChange={(e) => SetProductStatus(e, "rcm")}
                  checked={Products.Rcm ? Products.Rcm : false}
                />
              </span>
              <span className="product-catagory">
                TeleMed{" "}
                <input
                  type="checkbox"
                  onChange={(e) => SetProductStatus(e, "tele")}
                  checked={Products.TeleMed ? Products.TeleMed : false}
                />
              </span>
              <span className="product-catagory">
                Kiosk{" "}
                <input
                  type="checkbox"
                  onChange={(e) => SetProductStatus(e, "kiosk")}
                  checked={Products.Kiosk ? Products.Kiosk : false}
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder label-top-text font-medium">
                Company Logo
              </label>
              {Detail && Detail.COMPANY_LOGO ? (
                <a
                  role="button"
                  title="Download Attachment"
                  className="product-catagory"
                  printpath=""
                  filename=""
                >
                  <img src={Attachment} className="IconDocuments" />
                  {LoadLogo}
                </a>
              ) : (
                <a
                  title="Download Attachment"
                  role="button"
                  className="product-catagory"
                  printpath=""
                  filename=""
                  onClick={() => DownloadLogoAttachment()}
                >
                  <img src={Attachment} className="IconDocuments" />
                  No Attachment
                </a>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">&nbsp;</div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <input
              type="button"
              className="btnLinkGreen"
              id=""
              value="Update Information"
              onClick={() => UpdateProductType()}
            />
          </div>
        </div>
        <div className="row table-panel-header mt-4">
          <div className="col-md-12">
            <h6>Implementation Contacts</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Name{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.IMP_CONACT_NAME : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Phone{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.IMP_CONACT_PHONE : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Email{" "}
                <img
                  alt="Required"
                  src={requiredImg}
                  className="redboxRequired"
                />
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.IMP_CONACT_EMAIL : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">&nbsp;</div>
          </div>
        </div>
        <div className="row table-panel-header mt-4">
          <div className="col-md-12">
            <h6>EDI Setup</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <label className="field-placeholder label-top-text">
                Provider Type
              </label>
              <span className="tooltip-wrapper">
                <span
                  tooltip="Select Group if you want to bill under Group NPI or Solo if you want to bill under individual NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
              <span className="product-catagory">
                Group{" "}
                <input
                  type="radio"
                  name="providerType"
                  disabled
                  checked={
                    Detail
                      ? Detail.PROVIDER_TYPE === "Group"
                      : false
                  }
                />
              </span>
              <span className="product-catagory">
                Solo{" "}
                <input
                  type="radio"
                  name="providerType"
                  disabled
                  checked={
                    Detail
                      ? Detail.PROVIDER_TYPE === "Solo"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Medicare PTAN
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.GROUP_MCR_PTAN : ""}
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="Medicare assigned Provider Transaction Access Number, provide group PTAN if billing under group NPI or individual PTAN if billing under Individual NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Medicare RR PTAN
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.GROUP_MCR_RR : ""}
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="Medicare RailRoad assigned Provider Transaction Access Number, provide group PTAN if billing under group NPI or individual PTAN if billing under Individual NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">DME PTAN</label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.GROUP_MCR_DME : ""}
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="DME assigned Provider Transaction Access Number, provide group PTAN if billing under group NPI or individual PTAN if billing under Individual NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                BCBS Provider #
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.BCBS_PROVIDER : ""}
              />
              <span className="tooltip-wrapper">
                <span
                  tooltip="Blue Cross Blue Shield assigned provider number, provide group provider number if billing under group NPI or individual provider number if billing under Individual NPI"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">&nbsp;</div>
        </div>
        <div className="row table-panel-header mt-4">
          <div className="col-md-12">
            <h6>Questions</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                Email Appointment Reminder &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.EMAIL_APPT_REMINDER === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                ** Electronic Prescription Controlled Substance Set Up &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail ? (Detail.EPCS_SET_UP === "Y") : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                ** Call/SMS Appointment Reminder &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.CALL_SMS_APPT_REMINDER === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <span className="product-catagory">
                Lab Integration &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.LAB_INEGRATION === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                ** Direct Email &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.DIRECT_EMAIL === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                Electronic Prescription &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.ELECTRONIC_PRESCRIPTION === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                <span
                  tooltip="Insurance and Driver's License prepopulate via scanner"
                  className="info-tooltip"
                >
                  <img className="lbl-tooltip" src={InfoIcon} />
                </span>
                ** Prepopulating Patient based on ID Scan &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.PREPOPULATE_PATIENT === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                ** Electronic Patient Statement Service &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.ELECT_PAT_STATMENT_SERVICE === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
        </div>

        <div className="field-container border-none text-center">
          <span className="product-catagory">
            ** Additional Charges will aplly &nbsp;
          </span>
        </div>
        <div className="row table-panel-header mt-4">
          <div className="col-md-12">
            <h6>Data migration</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                Data Migration &nbsp;
                <input
                  type="checkbox"
                  disabled
                  checked={
                    Detail
                      ? Detail.DATA_MIGRATION === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">
                Previous EHR Vendor
              </label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value=""
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container">
              <label className="field-placeholder font-medium">Comments</label>
              <input
                type="text"
                className="field-input"
                placeholder=""
                disabled
                value={Detail ? Detail.COMMENTS : ""}
              />
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="field-container border-none">
              <span className="product-catagory">
                EHR Vendor Notified &nbsp;
                <input
                  type="checkbox"
                  checked={
                    Detail
                      ? Detail.EHR_NOTIFIED === "Y"
                      : false
                  }
                />
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-4">
            <ol>
              <li>
                (1) For Clinical data, Please send CCDA files. If sample data
                migration has been given then file format/layout should remain
                same in Production data migration
              </li>
              <li>
                (2) For patient demographics/insurances, our supported format
                will be CSV/Excel
              </li>
              <li>(3) For progress note, we support PDF/HTML/TIFF files.</li>
            </ol>
          </div>
        </div>
      </div>
  );
};

export default Setup;
